<gax-select-form-field-deprecated-use-mat-select
  [showInfoIcon]="displayCountryInfo || displaySocialTaxInfo"
  (infoIconClicked)="
    displaySocialTaxInfo
      ? showSocialTaxInformationModal()
      : showCountryInformationModal()
  "
  [label]="countryLabel"
  [formControl]="countryControl"
  (searchChanged)="onSearchCountry($event)"
  [required]="countryRequired"
>
  <gax-select-trigger>
    {{ countryControl.value | countryName: true }}
  </gax-select-trigger>

  @if (!countryRequired) {
    <gax-option
      class="text-underline font-bold color-transparent"
      [value]="null"
      (click)="clearSelection()"
    >
      Clear selection
    </gax-option>
  }

  @for (option of filteredCountries | async; track option.code) {
    <gax-option
      [value]="option.code"
      [disabled]="disabledCountries?.includes(option.code) || false"
    >
      {{ option.code | countryName: true }}
    </gax-option>
  }

  @if (showValidationErrors && countryControl.hasError("required")) {
    <gax-error>{{ countryLabel }} required</gax-error>
  }

  @if (
    showValidationErrors &&
    countryControl.hasError("duplicateIncomeBandingCountry")
  ) {
    <gax-error>
      This country has already been added to the income tax
    </gax-error>
  }

  @if (
    showValidationErrors && countryControl.hasError("duplicateSocialTaxCountry")
  ) {
    <gax-error>
      This country has already been added to the social tax
    </gax-error>
  }
</gax-select-form-field-deprecated-use-mat-select>

@if (
  regionControl &&
  (!countryRegionValidation ||
    locationFormHelper.supportsRegionCalculations(countryControl.value))
) {
  <gax-select-form-field-deprecated-use-mat-select
    class="mt-15"
    [label]="regionLabel"
    [hint]="
      showValidationErrors &&
      countryRegionValidation &&
      regionControl.invalid &&
      regionControl.pristine
        ? regionLabel + ' required for ' + (countryControl.value | countryName)
        : ''
    "
    [formControl]="regionControl"
    [search]="true"
    [required]="countryRegionValidation && regionRequired"
    (searchChanged)="onSearchRegion($event)"
  >
    @if (countryRegionValidation) {
      <gax-select-trigger>
        {{
          regionControl.value
            ? (regionControl.value | regionName: countryControl.value : true)
            : ""
        }}
      </gax-select-trigger>
      @if (!regionRequired) {
        <gax-option
          class="text-underline font-bold color-transparent"
          [value]="null"
          (click)="clearRegionSelection()"
        >
          Clear selection
        </gax-option>
      }

      @for (option of filteredRegions | async; track option.code) {
        <gax-option [value]="option.code">
          {{ option.code | regionName: countryControl.value : true }}
        </gax-option>
      }
    } @else {
      <gax-select-trigger>
        {{
          regionControl.value
            ? locationFormHelper.displayAllRegionNameAndCode(
                regionControl.value
              )
            : ""
        }}
      </gax-select-trigger>

      @if (!regionRequired) {
        <gax-option
          class="text-underline font-bold color-transparent"
          [value]="null"
          (click)="clearRegionSelection()"
        >
          Clear selection
        </gax-option>
      }

      @for (group of filteredRegionGroups | async; track group.countryCode) {
        <div
          class="resident-region-country-heading"
          role="presentation"
          aria-hidden="true"
        >
          {{ group.countryName }}
        </div>

        @for (region of group.regions; track region.code) {
          <gax-option class="resident-region-option" [value]="region.code">
            {{ region.name }} ({{ region.code }})
          </gax-option>
        }
      }
    }

    @if (
      showValidationErrors &&
      countryRegionValidation &&
      regionControl.hasError("required")
    ) {
      <gax-error>
        {{ regionLabel }} required for
        {{ countryControl.value | countryName }}
      </gax-error>
    }
  </gax-select-form-field-deprecated-use-mat-select>
}
